import { stockIsHKIndex } from '../helpers/stockCode.helper';
import { toastError } from '../helpers/toast.helper';
import { Region } from '../shared/types';
import { uiActions, userActions } from '.';

export {
  generalErrorHandler,
  resetAbortController,
  getRegionByStockCode,
  indexSearchStringMapper,
};

function generalErrorHandler(dispatch, next?: (error: Error) => void) {
  return (error: Error): void => {
    switch (error.name) {
      case 'AbortError': {
        return;
      }
      case 'ClientOutOfDate': {
        dispatch(uiActions.updater.forceUpdate());
        return;
      } // no need to propagate
      case 'UserNotMember': {
        dispatch(userActions.refresh());
        return;
      } // no need to propagate
      case 'UserTokenInvalid': {
        // TODO: check why this one doesn't work
        // and requires "error.message === 'Unauthorized'"
        dispatch(userActions.logout());
        return;
      } // no need to propagate
      default: {
        toastError(error);
        break;
      }
    }
    if (error.message === 'Unauthorized') {
      dispatch(userActions.logout());
      return;
    }
    if (next) next(error);
  };
}

const abortControllers = {};
function resetAbortController(key) {
  if (abortControllers[key] !== undefined) abortControllers[key].abort();
  abortControllers[key] = new AbortController();
  return abortControllers[key];
}

const getRegionByStockCode = (stockCode: string): 'hk' | 'us' => {
  const isHKStock = /^\d+$/.test(stockCode) || stockIsHKIndex(stockCode);
  return isHKStock ? 'hk' : 'us';
};

const indexSearchStringMapper: {
  searchString: string;
  stockCode: string;
  region: Region;
}[] = [
  { searchString: 'HSI', stockCode: '^HSI', region: 'hk' },
  { searchString: 'HSTECH', stockCode: '^HSTECH', region: 'hk' },
  { searchString: 'HSCEI', stockCode: '^HSCEI', region: 'hk' },
  { searchString: 'INX', stockCode: '^GSPC', region: 'us' },
  { searchString: 'DJI', stockCode: '^DJI', region: 'us' },
  { searchString: 'IXIC', stockCode: '^IXIC', region: 'us' },
];
